import { ContentType } from 'common/src/commentThread/types'
import { atomFamily, selectorFamily, useRecoilCallback } from 'recoil'
import { getCommentResponseTemplate } from '@/api/cb/commentResponseTemplate'
import {
    defaultInvalidationAtom,
    InvalidationAtom,
    invalidate,
} from '@/atoms/types'

export const commentResponseTemplateAtomFamily = atomFamily<
    string,
    ContentType
>({
    key: 'commentResponseTemplateAtomFamily',
    default: selectorFamily<string, ContentType>({
        key: 'commentResponseTemplateDefaultSelectorFamily',
        get:
            (contentType) =>
            async ({ get }) => {
                get(commentResponseTemplateInvalidationAtomFamily(contentType))
                const response = await getCommentResponseTemplate(contentType)
                return response.data.payload.template
            },
    }),
})

export const commentResponseTemplateInvalidationAtomFamily = atomFamily<
    InvalidationAtom,
    ContentType
>({
    key: 'commentResponseTemplateInvalidationAtomFamily',
    default: defaultInvalidationAtom,
    // WARNING: need to reset manually
})

// Hook to reset a template and refetch
export const useResetCommentResponseTemplate = () => {
    return useRecoilCallback(
        ({ set }) =>
            (contentType: ContentType) => {
                set(
                    commentResponseTemplateInvalidationAtomFamily(contentType),
                    (prev) => invalidate(prev)
                )
            },
        []
    )
}
